
import gql from 'graphql-tag';
import productPromotionFragment from '~/apollo/fragments/productPromotionFragment';
import savingPlanScenariosQuery from '~/apollo/queries/product/savingPlanScenario.gql';
import longtermSavTooltips from '~/apollo/queries/product/tooltips/longtermSavTooltips';
import commonProductDetailMixins from '~/mixins/commonProductDetailMixins.js';
import productPromotionMixins from '~/mixins/productPromotionMixins.js';
import productShortcutMixins from "~/mixins/productShortcutMixins.js";
import productInsuranceNameMixins from '~/mixins/productInsuranceNameMixins';

export default {
  mixins: [commonProductDetailMixins, productPromotionMixins, productShortcutMixins, productInsuranceNameMixins],

  data() {
    return {
      savingPlanScenarios: null,
      loading: 0,
      policyYear: this.$route.query.policy_year || null,
      riskLevelValue: this.$route.query.risk_level || null,
      currentLocale: this.$normalizeLocale(this.$i18n.locale),
    };
  },
  // page component definitions
  apollo: {
    $loadingKey: 'loading',
    savingPlanScenarios: {
      query: gql`
        ${savingPlanScenariosQuery}
        ${productPromotionFragment}
      `,
      prefetch: true,
      variables() {
        return {
          scenario_code: this.$route.params.slug,
          policy_year: parseInt(this.policyYear),
          locale: this.currentLocale,
        };
      },
    },
    longtermSavTooltips: {
      query: longtermSavTooltips,
      prefetch: true,
      variables() {
        return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
      },
      update(data) {
        return this.$normalizeStrapi(data.infoTooltip.data);
      },
    },
  },
  computed: {
    simpleItems() {
      if (this.savingPlanScenarios?.data[0]) {
        const item = this.savingPlanScenarios.data[0];
        // let promotionPrices = Array;
        // promotionPrices = [];

        const policyYear = this.policyYear?this.policyYear:(item.attributes.default_best_policy_year?item.attributes.default_best_policy_year:20);
        const riskLevelValue = this.riskLevelValue?this.riskLevelValue:(item.attributes.default_best_risk_level?item.attributes.default_best_risk_level:'Growth');

        let promotions = null;
        let promotion = null;
        let promotion_last_call = null;

        const planName = item.attributes.saving_plan.data.attributes.saving_plan_translations.data[0].attributes.name;
        const insurer = item.attributes.saving_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name;
        let decoderCTALink = this.$generateWhatsappCTALink(this.$t('products.longSavings.ls_categoryName'), insurer, planName);
        let decoderCTAText = '';

        const insuranceCompanyStat = item.attributes.saving_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.saving_input_insurer_fr_details.data;
        let insuranceCompanyStat6orAbove = [];
        let insuranceCompanyStatAll = [];

        const getShortcut = this.getProductShortcut(item.attributes);
        const shortcut = getShortcut.saving;
        const getFulfilmentShortcut = this.getSavingFulfilmentShortcut(item.attributes)
        const shortcutfilfulmentRatio = getFulfilmentShortcut.fulfilmentRatio;

        // separate insurance company statistic by policy year
        if (insuranceCompanyStat.length > 0) {
          for (let x of insuranceCompanyStat) {
            if (x.attributes.fr_criteria_policyyear == 'All') {
              insuranceCompanyStatAll.push(x);
            }
            else if (x.attributes.fr_criteria_policyyear == '6 or above') {
              insuranceCompanyStat6orAbove.push(x);
            }
          }
        }

        // check scenario level promo first , then plan level promotion
        if (item.attributes.product_promotions.data?.length > 0) {
          promotions = item.attributes.product_promotions.data;
        }
        if (item.attributes.saving_plan.data.attributes.product_promotions.data?.length > 0) {
          promotions = item.attributes.saving_plan.data.attributes.product_promotions.data;
        }

        if(promotions != null) {
          promotion = this.checkPromotionValid(promotions);
          promotion_last_call = this.checkPromotionLastCall(promotion);

          if (!promotion) {
            promotion = null;
          } else if (promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink) {
            decoderCTALink = promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink;
            decoderCTAText = this.$t('products.product_website');
          }
        }

        let specialFeatures = Array;
        specialFeatures = [];
        if (item.attributes.saving_plan.data.attributes.multi_currency) {
          specialFeatures.push({
            text: this.$t('products.longSavings.ls_multiCurrency'),
            type: 'currency'
          });
        }

        const filteredTranslations = this.getFilteredTranslations(item.attributes.saving_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
        .insurance_company_translations.data[0].attributes.localizations.data);

        return {
          scenario_code: item.attributes.scenario_code,
          pre_pay: item.attributes.pre_pay,

          plan_name: planName,
          fixed_allocation:
            item.attributes.saving_plan.data.attributes.saving_plan_translations.data[0].attributes.fixed_allocation,
          equity_allocation:
            item.attributes.saving_plan.data.attributes.saving_plan_translations.data[0].attributes.equity_allocation,
          bonus_philosophy_shareholders:
            item.attributes.saving_plan.data.attributes.saving_plan_translations.data[0].attributes
              .bonus_philosophy_shareholders,
          bonus_philosophy_policyholders:
            item.attributes.saving_plan.data.attributes.saving_plan_translations.data[0].attributes
              .bonus_philosophy_policyholders,

          insurer_name_first:
            item.attributes.saving_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
              .insurance_company_translations.data[0].attributes.name,
          insurer_name_second:
            filteredTranslations[0].attributes.name,
          insurer_logo:
            item.attributes.saving_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.logo,
          insurer_code:
            item.attributes.saving_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.code,

          g_return_ratio: this.getFinancialDetails(item, policyYear).g_return_ratio,
          p_return_ratio_base: this.getFinancialDetails(item, policyYear).p_return_ratio_base,
          p_return_ratio_pess: this.getFinancialDetails(item, policyYear).p_return_ratio_pess,
          scenarioID: item.id,
          product_promotion: promotion,
          decoder_cta_link: decoderCTALink,
          decoder_cta_text: decoderCTAText,
          shortcut: shortcut,
          shortcutfilfulmentRatio: shortcutfilfulmentRatio,

          // // ***** Overview *****
          currency: item.attributes.currency.data.attributes.currency_translations.data[0].attributes,
          currency_code: item.attributes.currency.data.attributes.code,

          payment_terms: item.attributes.payment_terms,

          // // ***** Return *****
          policy_year: this.getFinancialDetails(item, policyYear).policy_year,
          total_premium: item.attributes.total_premium,
          guarantee_cash: this.getFinancialDetails(item, policyYear).guarantee_cash,
          total_cash_pess: this.getFinancialDetails(item, policyYear).total_cash_pess,
          total_cash_base: this.getFinancialDetails(item, policyYear).total_cash_base,
          girr: this.getFinancialDetails(item, policyYear).girr,
          pirr_pess: this.getFinancialDetails(item, policyYear).pirr_pess,
          pirr_base: this.getFinancialDetails(item, policyYear).pirr_base,

          // // ***** Return *****
          acc_div_interest_base: this.getFinancialDetails(item, policyYear).acc_div_interest_base,
          acc_rev_bonus_base: this.getFinancialDetails(item, policyYear).acc_rev_bonus_base,
          td_base: this.getFinancialDetails(item, policyYear).td_base,

          acc_div_interest_pess: this.getFinancialDetails(item, policyYear).acc_div_interest_pess,
          acc_rev_bonus_pess: this.getFinancialDetails(item, policyYear).acc_rev_bonus_pess,
          td_pess: this.getFinancialDetails(item, policyYear).td_pess,
          fr_score: this.getFinancialDetails(item, policyYear).fr_score,
          // overall_score: this.getFinancialDetails(item, this.policyYear).overall_score,

          scenarioId: item.id,

          // ***** special features *****
          special_features: specialFeatures,
          promotion_last_call: promotion_last_call,

          // ***** insurer fulfillment ratio *****
          insurer_fulfillment_score: item.attributes.saving_plan.data.attributes.product.data.attributes.
            insurance_company.data.attributes.saving_input_insurer_ifs.data[0].attributes.fr_score,
          data_points_6_or_above: insuranceCompanyStat6orAbove[0].attributes.fr_count,
          data_points_all: insuranceCompanyStatAll[0].attributes.fr_count,
          average_fr_6_or_above: insuranceCompanyStat6orAbove[0].attributes.fr_average,
          average_fr_all: insuranceCompanyStatAll[0].attributes.fr_average,
          proportion_of_fr_6_or_above: 1 - (insuranceCompanyStat6orAbove[0].attributes.fr_freq_le70pct),
          proportion_of_fr_all: 1 - (insuranceCompanyStatAll[0].attributes.fr_freq_le70pct),

          // decoder update 2025
          // overall_score_highrisk: this.getFinancialDetails(item, this.policyYear).overall_score_highrisk,
          // overall_score_lowrisk: this.getFinancialDetails(item, this.policyYear).overall_score_lowrisk,
          overall_score: riskLevelValue==="Growth"?
            (this.getFinancialDetails(item, policyYear).overall_score_highrisk?this.getFinancialDetails(item, policyYear).overall_score_highrisk:0):
            (this.getFinancialDetails(item, policyYear).overall_score_lowrisk?this.getFinancialDetails(item, policyYear).overall_score_lowrisk:0),
          overall_star_goldenyears_lowrisk: this.getFinancialDetails(item, policyYear).overall_star_goldenyears_lowrisk,
          overall_star_education_lowrisk: this.getFinancialDetails(item, policyYear).overall_star_education_lowrisk,
          overall_star_retirement_lowrisk: this.getFinancialDetails(item, policyYear).overall_star_retirement_lowrisk,
          overall_star_legacy_lowrisk: this.getFinancialDetails(item, policyYear).overall_star_legacy_lowrisk,
          overall_star_goldenyears_highrisk: this.getFinancialDetails(item, policyYear).overall_star_goldenyears_highrisk,
          overall_star_education_highrisk: this.getFinancialDetails(item, policyYear).overall_star_education_highrisk,
          overall_star_retirement_highrisk: this.getFinancialDetails(item, policyYear).overall_star_retirement_highrisk,
          overall_star_legacy_highrisk: this.getFinancialDetails(item, policyYear).overall_star_legacy_highrisk,

          // enhance LTS detail page default display
          policyYear,
          riskLevelValue,
        };
      }
      return null;
    },

    product() {
      if (!this.simpleItems) return null;

      return {
        highlightSection: {
          scenarioCode: this.simpleItems.scenario_code,
          scenarioId: this.simpleItems.scenarioId,
          showFiveStarBadge: this.getStar(this.simpleItems),
          productName: this.simpleItems.plan_name,
          insuranceCompany: {
            name: this.simpleItems.insurer_name_first + ' | ' + this.simpleItems.insurer_name_second,
            code: this.simpleItems.insurer_code,
            logoSrc: this.simpleItems.insurer_logo?.data?.attributes?.url,
            logoAlt: this.simpleItems.insurer_name_first,
          },
          userRating: {
            score: this.getStar(this.simpleItems),
            numberOfRatedUser: '0',
          },
          tenlifeScore: {
            score: parseFloat(this.getScore(this.simpleItems)),
            description: this.getScoreLabel(),
            toolTipHtml: this.getScoreTooltip(),
          },
          features: [
            {
              text: this.simpleItems.pre_pay
                ? this.$t('products.longSavings.ls_prepaid')
                : this.simpleItems.payment_terms + this.$t('products.longSavings.ls_yearpayment'),
              type: 'payment_term',
            },
            {
              text: this.getCurrency(this.simpleItems.currency),
              type: 'currency',
            },
            ...this.simpleItems.special_features
          ],
          keyItems: [
            {
              value: this.$formatPercentage(this.simpleItems.g_return_ratio),
              key: this.$t('products.longSavings.ls_guaranteedReturnRatio'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey('ls_guaranteedReturnRatio'),
              symbolValue: '',
              originalValue: '',
            },
            {
              value: this.$formatPercentage(this.simpleItems.p_return_ratio_base),
              key: this.$t('products.longSavings.ls_projectedReturnRatioBase'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey('ls_projectedReturnBase'),
              symbolValue: '',
              originalValue: '',
            },
          ],
          mainButtonCTA: {
            text: this.simpleItems.decoder_cta_text,
            link: this.simpleItems.decoder_cta_link,
          },
          showShortcut: this.simpleItems.shortcut,
          showShortcutFulfilmentRatio: this.simpleItems.shortcutfilfulmentRatio,
        },
        detailSection: {
          details: [
            {
              id: 0,
              sectionTitle: this.$t('products.longSavings.ls_overview'),
              keyValues: [
                {
                  key: this.$t('products.longSavings.ls_overallScore'),
                  value: this.$formatScore(this.simpleItems.overall_score) + ' / 10',
                  keyToolTipHtml: this.getTooltipContentByKey('ls_overallScore'),
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_currency'),
                  value: this.getCurrency(this.simpleItems.currency),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_paymentTermYearly'),
                  value: this.simpleItems.pre_pay
                    ? this.$t('products.longSavings.ls_prepaid')
                    : this.simpleItems.payment_terms + this.$t('products.longSavings.ls_yearpayment'),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_targetAssetAllocation'),
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_fixed_incomeSecurities'),
                  value: this.simpleItems.fixed_allocation,
                  keyToolTipHtml: this.getTooltipContentByKey('ls_fixed_incomeSecurities'),
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_equity_typeSecurities'),
                  value: this.simpleItems.equity_allocation,
                  keyToolTipHtml: this.getTooltipContentByKey('ls_equity_typeSecurities'),
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_bonusPhilosophy_SharingofProfit'),
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_toPolicyholders'),
                  value: this.simpleItems.bonus_philosophy_policyholders
                    ? this.simpleItems.bonus_philosophy_policyholders
                    : this.$t('products.not_specified'),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_toShareholders'),
                  value: this.simpleItems.bonus_philosophy_shareholders
                    ? this.simpleItems.bonus_philosophy_shareholders
                    : this.$t('products.not_specified'),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
              ],
            },
            {
              id: 1,
              sectionTitle: this.$t('products.longSavings.ls_return'),
              keyValues: [
                {
                  key: this.$t('products.longSavings.ls_policyYear'),
                  value: this.simpleItems.policy_year,
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_internalRateofReturnIRR'),
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_guaranteedIRR'),
                  value: this.$formatPercentage(this.simpleItems.girr),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_projectedIRRBase'),
                  value: this.$formatPercentage(this.simpleItems.pirr_base),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_returnRatioCashValueOverTotalPremiumPaid'),
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_guaranteedReturnRatio'),
                  value: this.$formatPercentage(this.simpleItems.g_return_ratio),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_projectedReturnRatioBaseInDetail'),
                  value: this.$formatPercentage(this.simpleItems.p_return_ratio_base),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
              ],
            },
            {
              id: 2,
              sectionTitle: this.$t('products.longSavings.ls_cashValue'),
              keyValues: [
                {
                  key: this.$t('products.longSavings.ls_policyYear'),
                  value: this.simpleItems.policy_year,
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_guaranteedCashValue'),
                  value: this.simpleItems.currency_code + ' ' + this.$formatPrice(this.simpleItems.guarantee_cash),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_accumulatedDividendandInterest'),
                  value:
                    this.simpleItems.currency_code + ' ' + this.$formatPrice(this.simpleItems.acc_div_interest_base),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_accumulatedReversionaryBonus'),
                  value: this.simpleItems.currency_code + ' ' + this.$formatPrice(this.simpleItems.acc_rev_bonus_base),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_terminalDividend'),
                  value: this.simpleItems.currency_code + ' ' + this.$formatPrice(this.simpleItems.td_base),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_projectedCashValueBase'),
                  value: this.simpleItems.currency_code + ' ' + this.$formatPrice(this.simpleItems.total_cash_base),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_accumulatedDividendAndInterestOverProjectedCashValueBase'),
                  value: this.getPercentage(this.simpleItems.acc_div_interest_base, this.simpleItems.total_cash_base),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_accumulatedReversionaryBonusOverProjectedCashValueBase'),
                  value: this.getPercentage(this.simpleItems.acc_rev_bonus_base, this.simpleItems.total_cash_base),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_terminalDividendOverProjectedCashValueBase'),
                  value: this.getPercentage(this.simpleItems.td_base, this.simpleItems.total_cash_base),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
              ],
            },
            {
              id: 3,
              sectionTitle: this.$t('products.longSavings.ls_deathBenefit'),
              keyValues: [
                {
                  key: this.$t('products.longSavings.ls_guaranteedDeathBenefit'),
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_10thPolicyYear'),
                  value: 
                    this.getFinancialDetails(this.savingPlanScenarios.data[0], 10)?
                    this.simpleItems.currency_code +
                    ' ' +
                    this.$formatPrice(
                      this.getFinancialDetails(this.savingPlanScenarios.data[0], 10)?.guarantee_death_benefit
                    ):this.$t('products.longSavings.ls_policyEnded'),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_20thPolicyYear'),
                  value:
                    this.getFinancialDetails(this.savingPlanScenarios.data[0], 20)?
                    this.simpleItems.currency_code +
                    ' ' +
                    this.$formatPrice(
                      this.getFinancialDetails(this.savingPlanScenarios.data[0], 20)?.guarantee_death_benefit
                    ):this.$t('products.longSavings.ls_policyEnded'),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_30thPolicyYear'),
                  value:
                    this.getFinancialDetails(this.savingPlanScenarios.data[0], 30)?
                    this.simpleItems.currency_code +
                    ' ' +
                    this.$formatPrice(
                      this.getFinancialDetails(this.savingPlanScenarios.data[0], 30)?.guarantee_death_benefit
                    ):this.$t('products.longSavings.ls_policyEnded'),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_benefitmultiplier'),
                  value: '',
                  keyToolTipHtml: this.getTooltipContentByKey('ls_benefitmultiplier'),
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_10thPolicyYear'),
                  value: 
                    this.getFinancialDetails(this.savingPlanScenarios.data[0], 10)?
                    this.$formatMultiplier(
                      this.getFinancialDetails(this.savingPlanScenarios.data[0], 10)?.guarantee_death_multiplier
                    ):this.$t('products.longSavings.ls_policyEnded'),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_20thPolicyYear'),
                  value: 
                    this.getFinancialDetails(this.savingPlanScenarios.data[0], 20)?
                    this.$formatMultiplier(
                      this.getFinancialDetails(this.savingPlanScenarios.data[0], 20)?.guarantee_death_multiplier
                    ):this.$t('products.longSavings.ls_policyEnded'),
                    keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.longSavings.ls_30thPolicyYear'),
                  value: 
                    this.getFinancialDetails(this.savingPlanScenarios.data[0], 30)?
                    this.$formatMultiplier(
                      this.getFinancialDetails(this.savingPlanScenarios.data[0], 30)?.guarantee_death_multiplier
                    ):this.$t('products.longSavings.ls_policyEnded'),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
              ],
            },
            {
              id: 4,
              sectionTitle: this.$t('products.longSavings.ls_insurerFulfillmentRatios'),
              keyValues: [
                {
                  key: this.$t('products.longSavings.ls_fulfillmentRatioStatisticsPolicyYear6orAbove'),
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    {
                      key: this.$t('products.longSavings.ls_dataPoint'),
                      value: this.simpleItems.data_points_6_or_above == 0 ? "0" : this.simpleItems.data_points_6_or_above,
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    {
                      key: this.$t('products.longSavings.ls_averageFulfillmentRatiosPolicyYear6orAbove'),
                      value: this.simpleItems.data_points_6_or_above == 0 ? this.$t('not_applicable') : this.$formatPercentageDP(this.simpleItems.average_fr_6_or_above, 0),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    {
                      key: this.$t('products.longSavings.ls_proportionOfFulfillmentRatiosWhichAreHigherThan70'),
                      value: this.simpleItems.data_points_6_or_above == 0 ? this.$t('not_applicable') : this.$formatPercentageDP(this.simpleItems.proportion_of_fr_6_or_above, 0),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                  ],
                },
                {
                  key: this.$t('products.longSavings.ls_fulfillmentRatioStatisticsAllPolicyYear'),
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    {
                      key: this.$t('products.longSavings.ls_dataPoint'),
                      value: this.simpleItems.data_points_all == 0 ? "0" : this.simpleItems.data_points_all,
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    {
                      key: this.$t('products.longSavings.ls_averageFulfillmentRatios'),
                      value: this.simpleItems.data_points_all == 0 ? this.$t('not_applicable') : this.$formatPercentageDP(this.simpleItems.average_fr_all, 0),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    {
                      key: this.$t('products.longSavings.ls_proportionOfFulfillmentRatiosWhichAreHigherThan70'),
                      value: this.simpleItems.data_points_all == 0 ? this.$t('not_applicable') : this.$formatPercentageDP(this.simpleItems.proportion_of_fr_all, 0),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                  ],
                },
              ],
            }
          ],
          promotion: {
            category:
              this.simpleItems.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes
                ?.PromotionCategory,
            title:
              this.simpleItems.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes
                ?.PromotionTitle,
            ctaButtonLink:
              this.simpleItems.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes
                ?.CTAButtonLink,
            ctaButtonText:
              this.simpleItems.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes
                ?.CTAButtonText,
            promotionId: this.simpleItems.product_promotion?.id,
            scenarioId: this.simpleItems.scenarioId,
            lastCall: this.simpleItems.promotion_last_call

          },
        },
      };
    },
  },

  methods: {
    getFinancialDetails(item, policyYear) {
      const details = item.attributes.saving_plan_financial_details.data.filter((details) => {
        return details.attributes.policy_year === parseInt(policyYear);
      });
      if(details.length > 0)
        return details[0].attributes;
      
      return null;
    },

    getCurrency(curr) {
      if (this.currentLocale === 'zh-Hant-HK') {
        return curr.text;
      } else {
        return curr.localizations.data[0].attributes.text;
      }
    },

    getStar(product) {
      if(product.policyYear === '10') {
        return product.riskLevelValue==="Growth"?product.overall_star_goldenyears_highrisk:product.overall_star_goldenyears_lowrisk;
      } else if (product.policyYear === '20') {
        return product.riskLevelValue==="Growth"?product.overall_star_education_highrisk:product.overall_star_education_lowrisk;
      } else if (product.policyYear === '30') {
        return product.riskLevelValue==="Growth"?product.overall_star_retirement_highrisk:product.overall_star_retirement_lowrisk;
      } else if (product.policyYear === '60') {
        return product.riskLevelValue==="Growth"?product.overall_star_legacy_highrisk:product.overall_star_legacy_lowrisk;
      }
    },

    getScore(product) {
      return product.overall_score;
    },

    getScoreLabel() {
      return this.$t('products.longSavings.ls_overallScore');
    },

    getScoreTooltip() {
      return this.getTooltipContentByKey('ls_overallScore');
    },

    getTooltipContentByKey(mKey) {
      return this.longtermSavTooltips?.LongTermSav?.ToolTips?.find(({ Key }) => Key === mKey)?.ToolTipContent ?? '';
    },

    getPercentage(dividend, divisor)
    {
      if(divisor===0)
        return this.$t('products.longSavings.ls_notApplicale');
      else
        return this.$formatPercentage(dividend/divisor);
    }
  },
};
